var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panelWrap" }, [
    !_vm.noTitle
      ? _c(
          "div",
          { staticClass: "title-wrap" },
          [
            _c(
              "p",
              [
                _c("span", { staticClass: "panel-title" }, [
                  _vm._v(_vm._s(_vm.title)),
                ]),
                _vm._v(" "),
                _vm._t("header-info"),
              ],
              2
            ),
            _vm._v(" "),
            _vm._t("header-right"),
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "content" }, [_vm._t("default")], 2),
    _vm._v(" "),
    _c("div", { staticClass: "footer-wrap" }, [_vm._t("footer-right")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }